export const environment = {
  production: true,
  baseUrl: "https://api.postex.pk/services/merchant/api",
};
